import { FC } from 'react';
import {
  Theme,
  Button,
  ButtonSize,
  ButtonStyles,
  useBreakpoint,
  GenericLink,
  NextgenImage,
  LoaderType,
} from '@nextgen-web-framework/all';
import type { StepsToBusinessOwnerProps } from './types/propTypes';
import styles from './StepsToBusinessOwner.module.scss';
const StepsToBusinessOwner: FC<StepsToBusinessOwnerProps> = (props) => {
  const viewPortType = useBreakpoint();
  return (
    <div>
      <div className={styles['steps-to-busniness-owner-container']} data-testid={'steps-to-business-owner-test-id'}>
        <h3 className={styles['steps-title']}>{props.title}</h3>

        <div className={styles['steps-container']}>
          {props.businessSteps.map((item) => {
            const image = item?.image.find((image) => image?.viewport.includes(viewPortType));
            return (
              <div className={styles['step']} key={item.description}>
                <div className={styles['icon-conainer']}>
                  <NextgenImage
                    loaderType={LoaderType.CONTENTSTACK}
                    src={image?.url ?? ''}
                    fill={true}
                    alt={image?.altText ?? ''}
                    imageWidths={{
                      small: 36,
                      medium: 52,
                      large: 52,
                      xlarge: 52,
                    }}
                  />
                </div>
                <div className={styles['step-subtitle']}>{item.description}</div>
              </div>
            );
          })}
        </div>
        {props.link.text && (
          <div className={styles['steps-button']}>
            <GenericLink href={props.link.url} forceNative={false}>
              <Button
                title={props.link.text}
                buttonStyle={ButtonStyles.SOLID}
                theme={Theme.BLACK}
                size={ButtonSize.SMALL}
                data-testid="home-banner-explore-btn"
              />
            </GenericLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default StepsToBusinessOwner;
export type { StepsToBusinessOwnerProps };
